import { Text, Card, Flex, Button } from '@scale/scaleui-radix';
import { useState } from 'react';
import { ChevronDownIcon, ChevronRightIcon } from '@radix-ui/react-icons';

export function SectionCard({
  title,
  children,
  initCollapsed = false,
}: {
  title?: string;
  children: React.ReactNode;
  initCollapsed?: boolean;
}) {
  const [isExpanded, setIsExpanded] = useState(!initCollapsed);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <Card className="flex flex-col space-y-2 space-x-2">
      <Flex direction="column" gap="2">
        {title && (
          <Flex direction="row" align="center" gap="2">
            <Button variant="ghost" onClick={toggleExpanded} className="p-1 mx-[1px] h-auto w-auto">
              {isExpanded ? <ChevronDownIcon /> : <ChevronRightIcon />}
            </Button>
            <Text size="4">{title}</Text>
          </Flex>
        )}
        {isExpanded && children}
      </Flex>
    </Card>
  );
}
